export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8750.f7ec769f.jpg";